import config from '@/config';
import { FunctionalitiesEnum } from '@/config/types';
import { HOMEPAGE_BASE_PATH } from '@/logic/main/constants';
import { LogicContext } from '@/logic/main/types';
import { getSpecialRoutePath } from '@/logic/main/utils';

export const fetchPreviousPageInfo = async (
  context: LogicContext,
  event: unknown,
  params: {
    data?: { sidebar: boolean; modal: boolean; isClosingGameModal: boolean };
  }
) => {
  const basePath = config.base_path || HOMEPAGE_BASE_PATH;
  const previousPageArray = context.previousPageArray;
  let goBackNumber = 1;

  if (previousPageArray?.length) {
    if (params.data?.isClosingGameModal) {
      let lastGamePageIndex = previousPageArray.findIndex(({ pagePath }) =>
        pagePath.includes(
          getSpecialRoutePath(FunctionalitiesEnum.gameLaunch) + '/'
        )
      );

      if (lastGamePageIndex === -1) {
        lastGamePageIndex = previousPageArray.length;
      }

      const previousPagePath =
        previousPageArray[lastGamePageIndex - 1]?.pagePath || basePath;

      return {
        path: previousPagePath,
        previousPageArray: previousPageArray.slice(0, lastGamePageIndex - 1),
        mainLayoutPath: previousPagePath,
      };
    }

    if (params.data?.sidebar || params.data?.modal) {
      const numberOfRecentPagesInSidebar = findLastNotSidebarOrModalIndex(
        previousPageArray
      );
      goBackNumber += numberOfRecentPagesInSidebar;
    }

    const newPath =
      previousPageArray[previousPageArray.length - goBackNumber]?.pagePath ||
      basePath;

    return {
      path: newPath,
      previousPageArray: previousPageArray.slice(0, -goBackNumber),
      mainLayoutPath: newPath,
    };
  }

  return {
    path: basePath,
    mainLayoutPath: basePath,
  };
};

const findLastNotSidebarOrModalIndex = (
  previousPageArray: LogicContext['previousPageArray']
): number => {
  let numberOfPagesInSidebar = 0;
  const reversedPageArray = [...previousPageArray].slice().reverse();
  for (let page of reversedPageArray) {
    if (page.isInSidebar || page.isInModal) {
      numberOfPagesInSidebar++;
    } else {
      return numberOfPagesInSidebar;
    }
  }

  return numberOfPagesInSidebar;
};
